export enum AudiencesEnum {
  All = 'all',
  Adults = 'adults',
  Children = 'children',
  Custom = 'custom',
}
